import { render } from "./main_page.vue?vue&type=template&id=a9c041b2"
import script from "./main_page.vue?vue&type=script&lang=js"
export * from "./main_page.vue?vue&type=script&lang=js"

import "./main_page.vue?vue&type=style&index=0&id=a9c041b2&lang=stylus"

import exportComponent from "/Users/v.hirenko/Desktop/DevHubVault/Projects/Techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__